import moment from "moment"

/**
 * "3 days ago" for a review, question or answer. The server sends UTC
 * timestamps without a zone, so they are read as UTC and shown locally.
 */
export const formatWhen = (timestamp) =>
    timestamp ? moment.utc(timestamp).local().fromNow() : ""

/** "1 answer" / "3 answers" style counters. */
export const plural = (count, one, many = `${one}s`) =>
    `${count || 0} ${count === 1 ? one : many}`
